import "jquery-form";
import "jquery-validation"
import "../validator-rules";
import ssoAlert from "../tools/sso.alert";
import ssoAjax from "../tools/sso.ajax";

export function init() {
    const forgotPasswordForm = $('#forgot_password_form');
    const account = $('#account');
    const btnSubmit = $('#btn_submit');
    const btnBack = $('#btn_back');

    btnBack.on('click', function() {
        history.back();
    });

    forgotPasswordForm.validate({
        showErrors: function() {
            if (this.numberOfInvalids() > 0) {
                btnSubmit.addClass('disabled');
            } else {
                btnSubmit.removeClass('disabled');
            }

            this.defaultShowErrors();
        },
        errorElement: 'span',
        errorPlacement: function(error, element) {
            element.closest('.col').find('div.error-message').html(error);
        },
        submitHandler: function(form) {
            let forgotPasswordFinalUrl = coreUserForgotPasswordUrl.replace('{account}', account.val().trim());

            ssoAjax.setOptions({
                url: forgotPasswordFinalUrl
            }).submit(form, function(response) {
                try {
                    if (response.status === false) {
                        throw new Error(response.message);
                    }

                    ssoAlert.success(window.language.request_accepted, {
                        footer: `<a href="${loginUrl}" class="btn btn-primary text-white w-100 fw-bold">${globalLanguage.ok}</a>`,
                    });

                    ssoAjax.btnSetToSubmit();
                    $(form).resetForm();
                } catch (e) {
                    ssoAlert.error(e.message);
                }

                ssoAjax.btnSetToSubmit();
            });
        }
    });
}
